import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { FormItem } from '@microsec/models';
import { OK_LABEL } from '@microsec/constants';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormBuilderComponent } from '@microsec/components';

@Component({
  selector: 'app-offline-token-detail',
  templateUrl: './offline-token-detail.component.html',
  styleUrls: ['./offline-token-detail.component.scss'],
  imports: [FormBuilderComponent],
})
export class OfflineTokenDetailComponent extends BaseComponent implements OnInit {
  fields: FormItem[] = [];

  OK_LABEL = OK_LABEL;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
  ) {
    super();
  }

  ngOnInit() {
    this.fields = [
      Object.assign(new FormItem(), {
        label: 'Copy this offline token and store it securely outside of MicroIDS, as you will not be able to see it again.',
        field: 'text',
        labelStyleClass: 'mb-2',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: 'token',
        hasNoLabel: true,
        label: 'Offline Token',
        field: 'copy',
        defaultValue: this.dialogConfig?.data?.token,
        focused: true,
      } as FormItem),
    ];
  }
}
